module.exports = __webpack_public_path__ + "img/reports--avatar.34a73376.svg";